<!-- -------------------------------------------------------------- -->
<!-- successfully added dialog -->
<!-- -------------------------------------------------------------- -->

<mat-dialog-content>Task Successfully Added.</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>